import {
  TSemanticButtonVariant,
} from './semantic-button';

type TSemanticButtonLabelMap = Record<TSemanticButtonVariant, string>;

const german: TSemanticButtonLabelMap = {
  accept: 'Akzeptieren',
  add: 'Hinzufügen',
  back: 'Zurück',
  cancel: 'Abbrechen',
  close: 'Schließen',
  create: 'Erstellen',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  forward: 'Vorwärts',
  reset: 'Zurücksetzen',
  resetFilters: 'Filter zurücksetzen',
  save: 'Speichern',
  saveAsNew: 'Speichern unter ...',
  settings: 'Einstellungen',
  tableNavigation: '',
  upload: 'Hochladen',
  calculate: 'Berechnen',
  revision: 'Revision',
  fullscreen: 'Vollbild',
  optionMenu: 'Weitere Funktionen',
  duplicate: 'Duplizieren',
  refresh: 'Aktualisieren',
  copy: 'Kopieren',
  download: 'Herunterladen',
  moveUp: 'Nach oben verschieben',
  moveDown: 'Nach unten verschieben',
};

export default german;
